import { useCurrentCustomer } from '@collection-platform-frontend/api';
import { DropForm } from '@collection-platform-frontend/storefront';
import { Container, Loading } from '@collection-platform-frontend/ui';
import { Router, useRouter } from 'next/router';
import { AuthAction, withAuthUser } from 'next-firebase-auth';
import { useCallback } from 'react';

import { PageLayout } from '../../components/layout';

const currentApplicationId = process.env
  .NEXT_PUBLIC_X_COLLECTION_APPLICATION_ID as string;

type MintPageRouter = Router & {
  query: {
    slug: string;
    code: string;
    acquire_auto?: 'true';
  };
};

const MintPage = () => {
  const { query, push, reload, asPath } = useRouter() as MintPageRouter;
  const { slug, code, acquire_auto } = query;

  const { customer, authUser } = useCurrentCustomer(currentApplicationId, true);
  const myCustomer = customer?.myCustomer;
  const isNeedAuth = !authUser.emailVerified;

  const onLogin = useCallback(() => {
    const url = new URL('/auth', window.location.origin);
    url.searchParams.set('callbackUrl', asPath);

    push(url.toString());
  }, [push, asPath]);

  const onTop = useCallback(() => {
    push('/');
  }, [push]);

  const onReset = useCallback(() => {
    reload();
  }, [reload]);

  const onConfirm = useCallback(() => {
    push('/collection');
  }, [push]);

  return (
    <PageLayout authUser={authUser} user={myCustomer}>
      <Container className="px-2 py-8 sm:px-4" backgroundShadow>
        <DropForm
          needAuth={isNeedAuth}
          applicationId={currentApplicationId}
          slug={slug}
          initCode={code}
          acquireAuto={acquire_auto === 'true'}
          onLogin={onLogin}
          onNotFound={onTop}
          onBack={onTop}
          onReset={onReset}
          onConfirm={onConfirm}
        />
      </Container>
    </PageLayout>
  );
};

export default withAuthUser({
  whenAuthed: AuthAction.RENDER,
  whenUnauthedBeforeInit: AuthAction.SHOW_LOADER,
  whenUnauthedAfterInit: AuthAction.RENDER,
  LoaderComponent: Loading,
})(MintPage);
